/* Gift Reggie retains authority over identity, ownership and all writes. */
(() => {
  'use strict';
  const configNode = document.getElementById('pa-registry-flow-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const prefix = (config.root || '/').replace(/\/$/, '');
  const base = prefix + '/apps/giftregistry';
  const manage = base + '/manage';
  const create = base + '/create';
  const find = base + '/find';
  const key = 'pa-registry-preview-intent-v1';
  const loginReturnKey = 'pa-registry-login-return-v1';
  const returnProductKey = 'pa-registry-return-product-v1';
  const route = location.pathname.replace(/\/$/, '');
  const main = document.querySelector('main');
  const root = main?.querySelector('.giftreggie-front');
  const escape = value => String(value || '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const button = (text, href, primary = false) => `<a class="pa-flow-button${primary ? ' pa-flow-button--primary' : ''}" href="${escape(href)}">${escape(text)}</a>`;
  const login = target => prefix + '/customer_authentication/login?return_to=' + encodeURIComponent(target);
  const ownerEntry = config.signedIn ? manage : login(manage);
  let registryPromise;
  let registryLoadedAt=0;
  let verifiedSelection;
  let bypassButton;
  const attempts=new WeakMap();

  function panel(title, copy, actions, extra = '') {
    const element = document.createElement('section');
    element.className = 'pa-flow pa-flow-panel ' + extra;
    element.innerHTML = `<h2>${escape(title)}</h2><p>${escape(copy)}</p><div class="pa-flow-actions">${actions}</div>`;
    return element;
  }
  function readIntent() {
    try {
      const intent = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (!intent || !Number.isFinite(intent.time) || Date.now() - intent.time > 10 * 60 * 1000) { sessionStorage.removeItem(key); return null; }
      const url = new URL(intent.url, location.origin);
      if (url.origin !== location.origin || !url.pathname.includes('/products/')) return null;
      return intent;
    } catch (_) { return null; }
  }
  function readReturnProduct() {
    try {
      const product=JSON.parse(sessionStorage.getItem(returnProductKey)||'null');
      if(!product)return null;
      const url=new URL(product.url,location.origin);
      if(url.origin!==location.origin || !url.pathname.includes('/products/'))return null;
      return {url:url.pathname+url.search,title:String(product.title||'Tu producto')};
    }catch(_){return null;}
  }
  function touchIntent() {
    const intent=readIntent();if(!intent || Date.now()-intent.time<30000)return;
    intent.time=Date.now();try{sessionStorage.setItem(key,JSON.stringify(intent));}catch(_){}
  }
  function clearIntent() { try { sessionStorage.removeItem(key);sessionStorage.removeItem(returnProductKey); } catch (_) { /* Browser storage is optional. */ } }
  function rememberLoginReturn() {
    if(!readIntent())return;
    try { sessionStorage.setItem(loginReturnKey,JSON.stringify({time:Date.now(),target:manage})); } catch (_) { /* Native return_to remains the primary route. */ }
  }
  function redirectRegistry(target) {
    const url=new URL(target,location.origin);
    if(url.origin!==location.origin || !url.pathname.startsWith(base+'/'))return;
    if(route.startsWith(base)){
      try{sessionStorage.setItem('pa-gift-route-transition',JSON.stringify({target:url.pathname.replace(/\/$/,''),time:Date.now()}));}catch(_){}
      if(document.documentElement)document.documentElement.dataset.paGiftRedirecting='true';
    }
    location.replace(url.pathname+url.search);
  }
  function recoverLoginReturn() {
    try {
      const pending=JSON.parse(sessionStorage.getItem(loginReturnKey)||'null');
      if(!pending)return false;
      if(pending.target!==manage || !Number.isFinite(pending.time) || Date.now()-pending.time>10*60*1000){sessionStorage.removeItem(loginReturnKey);return false;}
      if(route===manage){sessionStorage.removeItem(loginReturnKey);return false;}
      // Some sign-in paths land on the homepage. Resume only an explicitly requested registry login.
      if(config.signedIn && route===prefix){sessionStorage.removeItem(loginReturnKey);redirectRegistry(manage);return true;}
    } catch (_) { /* Do not interrupt normal browsing when storage is unavailable. */ }
    return false;
  }
  function needsFirstList(lists) { return lists.length===0 && !!(readIntent()||readReturnProduct()); }
  function listAccessHelp(target, before = null) {
    if(!target || target.querySelector('.pa-flow-access-help'))return;
    const note=document.createElement('aside');note.className='pa-flow pa-flow-access-help';
    note.setAttribute('aria-label','Ayuda para acceder a tu lista');
    const support='https://wa.me/34613229908?text='+encodeURIComponent('Hola, necesito ayuda para encontrar o acceder a mi lista de nacimiento.');
    note.innerHTML='<strong>¿No encuentras tu lista o no puedes acceder?</strong><p>Puede estar bloqueada o haberse cerrado automáticamente al cumplirse un año. <a href="'+support+'" target="_blank" rel="noopener noreferrer">Escríbenos por WhatsApp</a> y te ayudamos a revisarla.</p>';
    if(before)before.before(note);else target.append(note);
  }
  function productForm(buttonElement) {
    let area = buttonElement.parentElement;
    while (area) {
      const forms = Array.from(area.querySelectorAll('form[action*="/cart/add"]'));
      if (forms.length) return forms.sort((a,b) => Number(!!b.querySelector('[name="quantity"]')) - Number(!!a.querySelector('[name="quantity"]')))[0];
      area = area.parentElement;
    }
    return null;
  }
  function saveIntent(buttonElement) {
    const form = productForm(buttonElement);
    if (!form) return null;
    const entries = Array.from(new FormData(form).entries()).filter(([name,value]) =>
      typeof value === 'string' && (name === 'id' || name === 'quantity' || /^properties\[/.test(name)));
    const variant = entries.find(([name]) => name === 'id')?.[1];
    const url = new URL(location.href); url.searchParams.set('pa_resume_registry','1');
    if (variant) url.searchParams.set('variant',variant);
    const intent = {time:Date.now(), url:url.pathname+url.search, entries,
      title:document.querySelector('h1')?.textContent.trim() || 'Tu producto'};
    try { sessionStorage.setItem(key, JSON.stringify(intent));sessionStorage.setItem(returnProductKey,JSON.stringify({url:intent.url,title:intent.title}));return intent; } catch (_) { return null; }
  }
  async function nativeDocument(url) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(),12000);
    try {
      const response = await fetch(url,{credentials:'same-origin',cache:'no-store',signal:controller.signal});
      if (!response.ok) throw new Error('Registry response');
      return new DOMParser().parseFromString(await response.text(),'text/html');
    } finally { clearTimeout(timer); }
  }
  function parseManage(doc) {
    const content = doc.querySelector('.giftreggie-manage');
    if (!content || content.querySelector('.giftreggie-manage-non-customer')) throw new Error('Session required');
    const lists = new Map();
    content.querySelectorAll('a[href]').forEach(link => {
      const url = new URL(link.getAttribute('href'), location.origin);
      const match = url.pathname.match(/\/apps\/giftregistry\/registry\/(\d+)\/?$/);
      if (url.origin !== location.origin || !match) return;
      if (!lists.has(match[1])) lists.set(match[1],{id:match[1],url:url.pathname,title:link.textContent.trim(),status:'unknown'});
    });
    return Array.from(lists.values());
  }
  async function status(list) {
    try {
      const doc = await nativeDocument(list.url);
      const registry = doc.querySelector('.giftreggie-manager');
      if (!registry) return list;
      registry.querySelectorAll('.giftreggie-registry-summary table').forEach(table => {
        const headings = Array.from(table.querySelectorAll('tr:first-child th'));
        const cells = Array.from(table.querySelectorAll('tr:nth-child(2) td'));
        const index = headings.findIndex(cell => /^(estatus|estado|status)$/i.test(cell.textContent.trim()));
        const value = cells[index]?.textContent.trim().toLowerCase();
        if (['open','abierta','abierto'].includes(value)) list.status='open';
        if (['closed','cerrada','cerrado'].includes(value)) list.status='closed';
      });
    } catch (_) { /* Unknown is not treated as open. */ }
    return list;
  }
  function registries({fresh=false}={}) {
    if(registryPromise && registryLoadedAt && (fresh || Date.now()-registryLoadedAt>60000)){registryPromise=null;registryLoadedAt=0;}
    if (!registryPromise) {
      const request=(async () => {
      const lists = route === manage && root ? parseManage(document) : parseManage(await nativeDocument(manage));
      // Bound concurrent requests while retaining every list returned by Gift Reggie.
      for (let i=0;i<lists.length;i+=3) await Promise.all(lists.slice(i,i+3).map(status));
      registryLoadedAt=Date.now();return lists;
      })();
      registryPromise=request;
      request.catch(()=>{if(registryPromise===request){registryPromise=null;registryLoadedAt=0;}});
    }
    return registryPromise;
  }
  function nativeSelectedId() {
    let settings = {};
    try { settings = JSON.parse(document.getElementById('gift_reggie_data')?.textContent || '{}'); } catch (_) {}
    document.querySelectorAll('[data-gift-reggie-data-override]').forEach(element => {
      try { settings = {...settings,...JSON.parse(element.textContent || '{}')}; } catch (_) {}
    });
    try {
      const managed = JSON.parse(localStorage.getItem('giftreggie-logged') || '{}');
      const cache = JSON.parse(localStorage.getItem('giftreggie-cache') || '{}');
      return String((managed.admin && managed.registry_id) || (settings.registryAdmin && settings.registryId) || cache.customer_registry_id || '');
    } catch (_) { return String(settings.registryAdmin && settings.registryId || ''); }
  }
  async function selectedRegistry(options) {
    const lists = await registries(options);
    const id = nativeSelectedId();
    return lists.find(list => list.id === id && list.status === 'open') || null;
  }
  function entryBar(before) {
    if (!before || document.querySelector('.pa-flow-owner-access')) return;
    const nav = document.createElement('p'); nav.className='pa-flow pa-flow-owner-access';
    nav.innerHTML='¿Ya tienes una lista? <a href="'+escape(ownerEntry)+'">Entra para gestionarla</a>.';
    const header=before.querySelector('header');if(header)header.after(nav);else before.before(nav);
  }
  async function managePage() {
    if (!root || route !== manage) return;
    const view = document.createElement('section'); view.className='pa-flow pa-flow-panel';
    view.innerHTML='<h1>Mi lista de nacimiento</h1><p class="pa-flow-status" role="status">Buscando las listas de tu cuenta…</p>';
    const native = document.createElement('div'); native.hidden=true; native.className='pa-flow-hidden';
    while (root.firstChild) native.appendChild(root.firstChild);
    root.append(view,native);
    if (!config.signedIn || native.querySelector('.giftreggie-manage-non-customer')) {
      view.innerHTML='<h1>Entra a tu lista</h1><p>Tu lista de nacimiento se gestiona con tu cuenta de cliente de Petit Abú, la misma que utilizas para comprar. No necesitas una cuenta aparte para la lista.</p><p>Si ya tienes una lista, entra con el mismo email con el que la creaste.</p><div class="pa-flow-actions">'+button('Entrar con mi cuenta de Petit Abú',login(manage),true)+'</div><p style="margin-top:18px">Después de entrar podrás gestionar tu lista o crear una nueva si todavía no tienes ninguna.</p>';
      listAccessHelp(view);
      return;
    }
    try {
      const lists = await registries();
      if(needsFirstList(lists)){redirectRegistry(create);return;}
      const open = lists.filter(list=>list.status==='open');
      const unknown = lists.filter(list=>list.status==='unknown');
      const closed = lists.filter(list=>list.status==='closed');
      if (open.length===1 && !unknown.length && !new URLSearchParams(location.search).has('choose')) {
        redirectRegistry(open[0].url); return;
      }
      const card = list => `<article class="pa-flow-card"><span class="pa-flow-tag">${list.status==='open'?'Abierta':list.status==='closed'?'Cerrada':'Revisar estado'}</span><h2>${escape(list.title)}</h2>${button(list.status==='closed'?'Ver lista cerrada':'Entrar a esta lista',list.url,list.status!=='closed')}</article>`;
      view.innerHTML='<h1>'+ (open.length+unknown.length?'Elige tu lista':'Mi lista de nacimiento')+'</h1><p>'+
        (open.length+unknown.length?'Entra en la lista que quieres gestionar y a la que quieres añadir productos.':closed.length?'Tus listas anteriores están cerradas. Puedes consultarlas o crear una nueva.':'No encontramos listas vinculadas a esta cuenta. Puedes crear una nueva o entrar con la cuenta que usaste antes.')+'</p>'+
        (open.length+unknown.length?'<div class="pa-flow-grid">'+[...open,...unknown].map(card).join('')+'</div>':'')+
        '<div class="pa-flow-actions">'+button('Crear una nueva lista',create,!open.length)+button('Buscar una lista para regalar',find)+'</div>'+
        (closed.length?'<details class="pa-flow-closed"><summary>Listas cerradas ('+closed.length+')</summary><div class="pa-flow-grid">'+closed.map(card).join('')+'</div></details>':'');
    } catch (_) {
      view.innerHTML='<h1>Entra a tu lista</h1><p>No hemos podido comprobar las listas de tu cuenta. Puedes volver a intentarlo o usar el acceso habitual.</p><div class="pa-flow-actions">'+button('Volver a intentarlo',manage,true)+'<button class="pa-flow-button" type="button" data-pa-native-manage>Mostrar mis listas</button></div>';
      view.querySelector('[data-pa-native-manage]').addEventListener('click',()=>{native.hidden=false;view.hidden=true;});
    }
    listAccessHelp(view);
  }
  function guestHint() {
    if (!root?.classList.contains('giftreggie-guest')) return;
    root.prepend(panel('¿Es tu lista?',config.signedIn?'Accede a tu lista desde tu cuenta de cliente de Petit Abú. Si la creaste con otro email, entra con ese email.':'Para editarla y añadir productos, entra con tu cuenta de cliente de Petit Abú y el mismo email con el que creaste la lista.',button('Entrar a mi lista',ownerEntry), 'pa-flow-note'));
  }
  function ownerResume() {
    const intent=readIntent();
    const product=intent||readReturnProduct();
    if (!product || !root?.classList.contains('giftreggie-manager')) return;
    const title=root.querySelector('.giftreggie-title h1,h1,h2')?.textContent.trim() || 'tu lista';
    const copy=intent?'Ya estás dentro de '+title+'. Vuelve al producto para revisar las opciones y confirmar que quieres añadirlo.':'Ya estás dentro de '+title+'. La selección anterior ha caducado. Vuelve al producto y elige de nuevo sus opciones antes de añadirlo.';
    const box=panel('Continúa con tu producto',copy,button('Volver al producto',product.url,true),'pa-flow-note');
    root.prepend(box);
  }
  function rootPage() {
    if (route!==base || !root) return;
    root.replaceChildren(panel('Tu lista de nacimiento','Entra a tu lista para gestionarla, busca una lista para hacer un regalo o crea una nueva.',button('Entrar a mi lista',ownerEntry,true)+button('Buscar una lista para regalar',find)+button('Crear una lista',create)));
  }
  function improveEntries() {
    if (route===prefix+'/pages/nacimiento') {
      const first=document.querySelector('main a[href*="/apps/giftregistry/signup"]');
      if(first) {
        const link=document.createElement('a');link.className='btn-ghost';link.href=ownerEntry;link.textContent='Entrar a mi lista';first.after(link);
      }
      document.querySelectorAll('main a[href*="/apps/giftregistry/signup"]').forEach(a=>a.href=create);
      return;
    }
    if (route===find) entryBar(document.querySelector('.pa-registry-search') || root);
    if (root?.classList.contains('giftreggie-create')) {
      const notice=document.querySelector('.pa-registry-create-notice');
      const link=notice?.querySelector('a');if(link){link.href=ownerEntry;link.textContent='Entrar a mi lista →';}
      const loggedOut=root.querySelector('.giftreggie-manage-non-customer');
      if(loggedOut) {
        const note=panel('Tu lista, con tu cuenta de Petit Abú','Usa tu cuenta de cliente de Petit Abú, la misma que utilizas para comprar. No necesitas una cuenta aparte para tu lista de nacimiento.',button('Entrar con mi cuenta de Petit Abú',login(manage),true));
        note.classList.add('pa-flow-login');
        const explanation=document.createElement('p');explanation.textContent='Después de entrar podrás acceder a tu lista o crear una nueva. Si ya tienes una, usa el mismo email con el que la creaste.';
        note.querySelector('.pa-flow-actions').before(explanation);
        loggedOut.replaceChildren(note);
        if(notice)notice.hidden=false;
      }
      listAccessHelp(root);
    }
    if (root && route.endsWith('/orders') && /No hay órdenes asociadas/.test(root.textContent)) {
      const text=Array.from(root.childNodes).find(node=>node.nodeType===Node.TEXT_NODE && /No hay órdenes asociadas/.test(node.textContent));
      if(text)text.textContent='Todavía no hay compras registradas en esta lista.';
    }
  }
  function dialog(title,copy,actions) {
    document.querySelector('.pa-flow-modal-backdrop')?.remove();
    const backdrop=document.createElement('div');backdrop.className='pa-flow-modal-backdrop';
    const content=panel(title,copy,actions);content.setAttribute('role','dialog');content.setAttribute('aria-modal','true');content.setAttribute('aria-label',title);content.tabIndex=-1;
    const close=document.createElement('button');close.className='pa-flow-button';close.textContent='Seguir viendo el producto';close.type='button';close.addEventListener('click',()=>{backdrop.remove();document.querySelector('.giftreggie-pdp-registry-cta')?.focus();});
    content.querySelector('.pa-flow-actions').append(close);backdrop.append(content);document.body.append(backdrop);content.focus();
    backdrop.addEventListener('keydown',event=>{if(event.key==='Escape')close.click();if(event.key==='Tab'){const controls=Array.from(content.querySelectorAll('a,button'));if(event.shiftKey && (document.activeElement===controls[0]||document.activeElement===content)){event.preventDefault();controls.at(-1)?.focus();}else if(!event.shiftKey&&document.activeElement===controls.at(-1)){event.preventDefault();controls[0]?.focus();}}});
  }
  async function productContext() {
    if(!config.product)return;
    let noLists=false;
    if(config.signedIn) { try{noLists=(await registries()).length===0;verifiedSelection=await selectedRegistry();}catch(_){verifiedSelection=null;} }
    let resumed=false;
    let contextCounter=0;
    const update=()=>document.querySelectorAll('.giftreggie-pdp-registry-cta').forEach(cta=>{
      if(cta.dataset.paFlowContext==='true')return;
      cta.dataset.paFlowContext='true';
      if(!cta.id)cta.id='pa-flow-registry-cta-'+(++contextCounter);
      const note=document.createElement('p');note.className='pa-flow pa-flow-add-context';
      note.dataset.paCta=cta.id;
      note.innerHTML=verifiedSelection?'Añadirás este producto a <strong>'+escape(verifiedSelection.title)+'</strong>. <a href="'+manage+'?choose=1">Cambiar lista</a>':noLists?'Todavía no tienes una lista. Al pulsar «Añadir a la lista» podrás crearla y después retomar este producto.':config.signedIn?'Entra a tu lista para añadir productos. <a href="'+manage+'">Entrar a mi lista</a>':'Para añadirlo a tu lista, entra con tu cuenta de cliente de Petit Abú.';
      (cta.closest('.giftreggie-pdp-cta-area') || cta).after(note);
      if(!resumed){resumed=true;restoreProduct();}
    });
    update();new MutationObserver(update).observe(document.body,{childList:true,subtree:true});
  }
  async function restoreProduct() {
    const intent=readIntent();if(!intent || !new URLSearchParams(location.search).has('pa_resume_registry'))return;
    const cta=document.querySelector('.giftreggie-pdp-registry-cta');
    const form=cta && productForm(cta);if(!form)return;
    const intendedId=intent.entries.find(([name])=>name==='id')?.[1];
    const currentId=form.querySelector('[name="id"]')?.value;
    if(intendedId!==currentId){dialog('Revisa tu selección','No hemos podido recuperar la misma variante. Selecciona de nuevo las opciones antes de añadir el producto.',button('Entrar a mi lista',manage));return;}
    let restored=true;
    for(const [name,value] of intent.entries) {
      if(name==='id'||name==='properties[_bundle_selection]')continue;
      if(name.startsWith('properties[')) {
        const option=name.slice(11,-1);
        const swatch=Array.from(document.querySelectorAll('[data-sb-io-swatch]')).find(e=>e.dataset.propKey===option&&e.dataset.optionValue===value);
        if(swatch&&!swatch.disabled){swatch.click();continue;}
        if(swatch || Array.from(document.querySelectorAll('[data-sb-io-swatch]')).some(e=>e.dataset.propKey===option)){restored=false;continue;}
      }
      const fields=Array.from(form.elements).filter(e=>e.name===name&&!e.disabled);
      const field=fields.find(e=>e.type!=='radio'&&e.type!=='checkbox')||fields.find(e=>e.value===value);
      if(!field){restored=false;continue;}
      if(field.type==='radio'||field.type==='checkbox')field.checked=true;else field.value=value;
      field.dispatchEvent(new Event('input',{bubbles:true}));field.dispatchEvent(new Event('change',{bubbles:true}));
    }
    await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
    const after=Array.from(new FormData(form).entries());
    form.dataset.paFlowRestoreMissing=JSON.stringify(intent.entries.filter(([name,value])=>!after.some(([a,b])=>a===name&&b===value)).map(([name])=>name));
    restored=restored&&intent.entries.every(([name,value])=>after.some(([a,b])=>a===name&&b===value));
    form.dataset.paFlowRestoreStatus=restored?'restored':'review';
    if(!restored){const context=document.querySelector('.pa-flow-add-context');if(context){const warning=document.createElement('span');warning.textContent=' Revisa los colores antes de añadirlo.';context.append(warning);}}
  }

  // Capture before the existing feedback observer and before Gift Reggie's native click handler.
  document.addEventListener('click', async event=>{
    const loginLink=event.target.closest?.('a[href]');
    if(loginLink){try{const url=new URL(loginLink.href,location.origin);if(url.origin===location.origin && url.pathname===prefix+'/customer_authentication/login' && url.searchParams.get('return_to')===manage)rememberLoginReturn();}catch(_){}}
    const changeLink=event.target.closest?.('.pa-flow-add-context a');
    if(changeLink){const buttonElement=document.getElementById(changeLink.closest('.pa-flow-add-context')?.dataset.paCta);if(buttonElement)saveIntent(buttonElement);return;}
    const cta=event.target.closest?.('.giftreggie-pdp-registry-cta');
    if(!cta || !config.product)return;
    if(bypassButton===cta){bypassButton=null;return;}
    event.preventDefault();event.stopImmediatePropagation();
    if(cta.dataset.paFlowChecking==='true')return;
    if(cta.dataset.paRegistryState==='uncertain'){document.dispatchEvent(new CustomEvent('pa:registry-review',{detail:{button:cta}}));return;}
    if(['pending','success'].includes(cta.dataset.paRegistryState))return;
    if(!config.signedIn){
      const saved=saveIntent(cta);
      dialog('Continúa para añadirlo a tu lista',saved?'Entra con tu cuenta de cliente de Petit Abú. Si ya tienes una lista, iremos a ella. Si todavía no tienes ninguna, te llevaremos a crearla. Conservaremos este producto para que puedas retomarlo después.':'Entra con tu cuenta de cliente de Petit Abú. Si aún no tienes una lista, podrás crearla después y volver a este producto.',button('Entrar y continuar',login(manage),true));return;
    }
    cta.dataset.paFlowChecking='true';cta.setAttribute('aria-busy','true');
    try{
      const selected=await selectedRegistry({fresh:true});
      if(!selected){saveIntent(cta);if((await registries()).length===0){location.assign(create);return;}dialog('Elige tu lista','Entra en la lista a la que quieres añadir este producto. Después podrás volver aquí con tu selección.',button('Elegir mi lista',manage+'?choose=1',true));return;}
      // A native selected context must agree with the verified account list; do not fabricate app storage.
      const selectedId=nativeSelectedId();
      if(selectedId && selectedId!==selected.id){saveIntent(cta);location.assign(manage);return;}
      const draft=saveIntent(cta);if(draft)attempts.set(cta,draft);
      bypassButton=cta;cta.click();
    }catch(_){saveIntent(cta);dialog('Comprueba tu lista antes de añadirlo','No hemos podido comprobar el destino. Entra a tu lista y vuelve al producto para continuar.',button('Entrar a mi lista',manage,true));}
    finally{cta.dataset.paFlowChecking='false';if(!['pending'].includes(cta.dataset.paRegistryState))cta.setAttribute('aria-busy','false');}
  },true);
  document.addEventListener('pa:registry-added',event=>{
    const saved=attempts.get(event.detail?.button);const current=readIntent();
    if(saved&&current&&saved.time===current.time&&JSON.stringify(saved.entries)===JSON.stringify(current.entries))clearIntent();
    if(event.detail?.button)attempts.delete(event.detail.button);
  });
  // Only activity in the native required registration form refreshes the ten-minute idle window.
  ['input','change','submit'].forEach(type=>document.addEventListener(type,event=>{if(event.target.closest?.('#giftreggie-create-form'))touchIntent();},true));
  document.addEventListener('click',event=>{if(event.target.closest?.('.pa-flow-note a[href*="/products/"]'))touchIntent();},true);
  window.addEventListener('pageshow',()=>{bypassButton=null;});
  // Run after native and existing deferred form/search enhancements have mounted.
  function start(){if(recoverLoginReturn())return;improveEntries();guestHint();ownerResume();rootPage();window.paRegistryRouteReady=managePage();productContext();}
  if(document.readyState!=='complete')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
